<script setup lang="ts">
import type { PropType } from 'vue';
import { computed } from 'vue';

const props = defineProps({
    type: { type: [Object, Map] as PropType<Record<string, string> | Map<string, string> | undefined>, required: false, default: undefined },
    value: { type: [String, null] as PropType<string | null | undefined>, required: false, default: undefined },
});

const value = computed(() => {
    const _title = props.value ?? '';
    let _value = '';
    const _type = props.type;
    if(_type instanceof Map) {
        _value = String(_type.get(_title) ?? '');
    } else if(_type && (_type instanceof Object)) {
        _value = String(_type[_title] ?? '');
    }

    const array = [
        _title,
        (_title && _value) ? ' - ' : '',
        _value,
    ];

    return array;
});
</script>
<template>
    <span>
        <strong v-if="value[0]">{{ value[0] }}{{ value[1] }}</strong>
        {{ value[2] }}
    </span>
</template>
